var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "./Icon";
import Thumbnails from "./Thumbnails";
import React, { useState, useRef, Fragment, } from 'react';
import { layout } from 'styled-system';
import { styled, css, mq } from "../utils";
var PicturesContainer = styled.div(function (_a) {
    var space = _a.theme.space, hasMargin = _a.hasMargin;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), hasMargin ? space.normal : '0px');
});
var Wrapper = styled.div(function (_a) {
    var _b = _a.theme, space = _b.space, colors = _b.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    cursor: grab;\n    display: flex;\n    flex-direction: column;\n\n    .image-container {\n      display: flex;\n      position: relative;\n      width: 100%;\n      aspect-ratio: 4/3;\n    }\n\n    .slider-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      display: none;\n    }\n\n    .slider-image.active {\n      display: block;\n      cursor: grabbing;\n    }\n\n    .dots-container {\n      margin-top: ", ";\n      margin-bottom: ", ";\n      display: flex;\n      text-align: center;\n      justify-content: center;\n    }\n\n    .dot {\n      padding: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      background-color: ", ";\n      cursor: pointer;\n      border: 1px solid ", ";\n    }\n\n    .dot.active {\n      background-color: ", ";\n    }\n\n    .fullscreen {\n      cursor: pointer;\n      position: absolute;\n\n      ", ";\n    }\n  "], ["\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    cursor: grab;\n    display: flex;\n    flex-direction: column;\n\n    .image-container {\n      display: flex;\n      position: relative;\n      width: 100%;\n      aspect-ratio: 4/3;\n    }\n\n    .slider-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      display: none;\n    }\n\n    .slider-image.active {\n      display: block;\n      cursor: grabbing;\n    }\n\n    .dots-container {\n      margin-top: ", ";\n      margin-bottom: ", ";\n      display: flex;\n      text-align: center;\n      justify-content: center;\n    }\n\n    .dot {\n      padding: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      background-color: ", ";\n      cursor: pointer;\n      border: 1px solid ", ";\n    }\n\n    .dot.active {\n      background-color: ", ";\n    }\n\n    .fullscreen {\n      cursor: pointer;\n      position: absolute;\n\n      ", ";\n    }\n  "])), space[3], space[4], colors.white, colors.primary, colors.primary, mq({ bottom: [space[1], space[6]], left: [space[1], space[6]] }));
}, layout);
var ImageSlider = function (_a) {
    var pictures = _a.pictures, openGallery = _a.openGallery, _b = _a.withDots, withDots = _b === void 0 ? true : _b, withThumbnails = _a.withThumbnails, thumbnailsAspectRatio = _a.thumbnailsAspectRatio, props = __rest(_a, ["pictures", "openGallery", "withDots", "withThumbnails", "thumbnailsAspectRatio"]);
    var hasMargin = pictures.length <= 1;
    var _c = useState(0), currentImageIndex = _c[0], setCurrentImageIndex = _c[1];
    var containerRef = useRef(null);
    var startPosition = 0;
    var swiping = false;
    var goToImage = function (index) { return setCurrentImageIndex(index); };
    var goToNext = function () { return setCurrentImageIndex(function (prev) { return (prev + 1) % pictures.length; }); };
    var goToPrevious = function () {
        return setCurrentImageIndex(function (prev) { return (prev - 1 + pictures.length) % pictures.length; });
    };
    var handleTouchStart = function (event) {
        var _a;
        if (event.touches.length > 0) {
            var position = (_a = event.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX;
            handleSwipeStart(position);
        }
    };
    var handleMouseDown = function (event) {
        var position = event.clientX;
        handleSwipeStart(position);
    };
    var handleSwipeStart = function (position) {
        swiping = true;
        startPosition = position;
    };
    var handleSwipeMove = function (position) {
        if (!swiping)
            return;
        var difference = startPosition - position;
        if (difference > 50) {
            goToNext();
            swiping = false;
        }
        else if (difference < -50) {
            goToPrevious();
            swiping = false;
        }
    };
    var handleTouchMove = function (event) {
        var currentPosition = event.touches[0].clientX;
        handleSwipeMove(currentPosition);
    };
    var handleMouseMove = function (event) {
        if (!swiping)
            return;
        var currentPosition = event.clientX;
        handleSwipeMove(currentPosition);
    };
    var handleSwipeEnd = function () {
        swiping = false;
    };
    return (React.createElement(Wrapper, __assign({ className: "image-slider", ref: containerRef }, props),
        React.createElement(PicturesContainer, { hasMargin: hasMargin, className: "image-container", onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseUp: handleSwipeEnd, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleSwipeEnd }, pictures.map(function (image, index) { return (React.createElement(Fragment, { key: index },
            React.createElement("img", { src: image, alt: "Slide ".concat(index), onClick: function () { return openGallery(currentImageIndex); }, className: "slider-image ".concat(index === currentImageIndex ? 'active' : '') }),
            openGallery && (React.createElement(Icon.Fullscreen, { className: "fullscreen", onClick: function () { return openGallery(currentImageIndex); } })))); })),
        withDots && !withThumbnails && pictures.length > 1 && (React.createElement("div", { className: "dots-container" }, pictures.map(function (_, index) { return (React.createElement("span", { key: index, className: "dot ".concat(index === currentImageIndex ? 'active' : ''), onClick: function () { return goToImage(index); } })); }))),
        withThumbnails && pictures.length > 1 && (React.createElement(Thumbnails, { currentImageIndex: currentImageIndex, setCurrentImageIndex: setCurrentImageIndex, pictures: pictures, aspectRatio: thumbnailsAspectRatio }))));
};
export default ImageSlider;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ImageSlider.js.map